import { OPEN_IN_EMBED_ENABLED } from '../../common/constants/experiments/popout';

export default function canExecutePlayerPopout(state) {
  const {
    config: { autoupdate },
  } = state;

  return autoupdate[OPEN_IN_EMBED_ENABLED];
}
